<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {mapState} from 'vuex';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        carUserTypeOptions: [],
        orgIdOptions: [],
        form: [
          { // 司机账号
            label: '司机账号',
            value: 'loginAcct',
            type: 'input',
            placeholder: '请输入司机账号',
          },
          { // 司机名称
            label: '司机名称',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入司机名称',
          },
          { // 司机类型
            label: '司机类型',
            value: 'carUserType',
            type: 'select',
            default: -1,
            placeholder: '请选择司机类型',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            default: -1,
            placeholder: '请选择归属部门',
          },
          { // 归属车队
            label: '归属车队',
            value: 'companyName',
            type: 'input',
            placeholder: '请输入归属车队',
          },
          { // 车队联系人
            label: '车队联系人',
            value: 'attachTennantLinkman',
            type: 'input',
            placeholder: '请输入车队联系人',
          },
          { // 车队电话
            label: '车队电话',
            value: 'attachTennantLinkPhone',
            type: 'input',
            placeholder: '请输入车队电话',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'DRIVER_TYPE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.carUserTypeOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.orgIdOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...((await getDepartmentAllList({
        isArchive: true,
      })) || []),
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
